
import React, {useContext} from 'react'
import {NavLink} from 'react-router-dom'
import readEffect from "../../card/readEffect.json";
import img1 from "../../view/HD-Wallpapers.jpg";
import { BackIndex } from '../../context/BackIndex'
import "./CartStyle.css";

export function CartRead() {
      function selectImg(e) { if (e === "NaN") { return img1 } else { return e } }
      const  { setIndex , setIndexNav } = useContext(BackIndex)
      function name(x) {
        setIndex(x)
        setIndexNav("/leidos")
      }
      function nameHome(x) {
        setIndex(x)
        setIndexNav("/Super")
      }
  return(
    <>
      <li style={{position:"absolute",textAlign:"center",width:"100%",alignItems:"center",marginTop:"-12%",zIndex:"1", color:"white",fontFamily:"Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"}} >LISTA DE ARTICULOS MAS LEÍDOS</li>
      <li style={{position:"absolute",textAlign:"center",width:"100%",alignItems:"center",marginTop:"-7%",marginBottom:"5px",zIndex:"1",fontFamily:"Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"}}> <NavLink style={{textAlign:"center",width:"100%", color:"white",alignItems:"center" ,textDecoration:"none"}} to={"/"} onClick={() => { nameHome(1) }} >Volver A Lista Original   </NavLink></li>
      <div id="container_cart" >
        {readEffect.map((e, index) => {
        return (
          <div className="primer" key={index} style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
            <section className="primer_seccion">
              <div className="total_tarjeta">
                <h1 className="total_superTitle">{e.title[1]}</h1>
                <br />
              </div>
              <div className="total_vista">
                <img src={ selectImg(e.img[0]) } alt="Foto" />
                <br /><br />
              </div>
              <div className="total_cuerpo">
                <h4 className="Total_title">{e.lasttitle[1]}</h4>
                <p className="Total_parrafo">{e.epigraph[1]}</p>
              </div>
              <NavLink to= {`/Super/${e.slug}`} onClick={() => { name(`${index+1}`); }} id="navegador" lang="es" >Ve a cualquier parte</NavLink>
            </section>
          </div>
        );
      })}
    </div>
    
    </>
  );
}